// ==========================================
// 共通：全部表示されている時だけ矢印を消す（非loopのみ）
// ==========================================
function setupSplideArrowVisibility(splide, root) {
  // type: 'loop' の場合は常に矢印を残す
  if (splide.options.type === 'loop') {
    return;
  }

  var list = root.querySelector('.splide__list');
  if (!list) {
    return;
  }

  // list 全体の横幅が、表示領域以内に収まっていれば左右矢印を隠す
  var arrows = root.querySelector('.splide__arrows');
  if (!arrows) {
    return;
  }

  var shouldHide = (list.scrollWidth <= list.clientWidth + 1);
  arrows.style.display = shouldHide ? 'none' : '';
}

// ==========================================
// 共通：data-* から true / false を取得するヘルパー
//   例）data-pagination="false" などで制御
// ==========================================
function getSplideBoolOption(el, key, defaultValue) {
  var val = el.dataset[key];

  if (val == null || val === '') {
    return defaultValue;
  }

  val = String(val).toLowerCase();

  if (val === 'false' || val === '0' || val === 'off' || val === 'no') {
    return false;
  }
  if (val === 'true' || val === '1' || val === 'on' || val === 'yes') {
    return true;
  }

  return defaultValue;
}

// ==========================================
// 共通：data-gap から数値(px)を取得するヘルパー
//   未指定・変換不可なら defaultValue を返す
// ==========================================
function getSplideGap(el, defaultValue) {
  var val = el.dataset.gap;

  if (val == null || val === '') {
    return defaultValue;
  }

  var num = parseInt(val, 10);
  if (isNaN(num)) {
    return defaultValue;
  }

  return num;
}

// ==========================================
// Splide 初期化関数
// （初回ロード + reloadCotent 後どちらでも使える）
// ==========================================
window.initSplideCarousels = window.initSplideCarousels || function (root) {
  var rootEl = root || document;

  // ------------------------------------------
  // ① splide-items（5→4→3→2→1）
  // ------------------------------------------
  rootEl.querySelectorAll('.splide-items').forEach(function (el) {

    if (el.dataset.splideInited === '1') {
      if (el.__splide && typeof el.__splide.refresh === 'function') {
        try { el.__splide.refresh(); } catch (e) {}
        setupSplideArrowVisibility(el.__splide, el);
      }
      return;
    }
    el.dataset.splideInited = '1';

    var autoplay = el.dataset.autoplay === 'true';
    var type = el.dataset.type || 'loop';
    var pagination = getSplideBoolOption(el, 'pagination', true);
    // pagination=false のときはループさせない
    var typeFinal = pagination ? type : 'slide';
    var arrows = getSplideBoolOption(el, 'arrows', true);
    var gap = getSplideGap(el, 20);

    // slideは既定でフリースクロールにする（data-free-scrollで上書き可）
    var freeScrollDefault = (typeFinal === 'slide');
    var freeScroll = getSplideBoolOption(el, 'freeScroll', freeScrollDefault);

    var options = {
      type: typeFinal,
      padding: '3rem',
      perPage: 5,
      gap: gap + 'px',
      autoplay: autoplay,
      pauseOnHover: true,
      arrows: arrows,
      pagination: pagination,
      rewind: false,
      breakpoints: {
        1300: { perPage: 5 },
        1200: { perPage: 4 },
        992: { perPage: 3 },
        768: { perPage: 2 },
        480: { perPage: 1 }
      }
    };

    if (freeScroll) {
      options.drag = 'free';
      options.snap = false;
    }

    var splide = new Splide(el, options).mount();
    el.__splide = splide;

    setupSplideArrowVisibility(splide, el);
  });


  // ------------------------------------------
  // ② splide-fixed-items（data-width が効く版）
  // ------------------------------------------
  rootEl.querySelectorAll('.splide-fixed-items').forEach(function (el) {

    if (el.dataset.splideInited === '1') {
      if (el.__splide && typeof el.__splide.refresh === 'function') {
        try { el.__splide.refresh(); } catch (e) {}
        setupSplideArrowVisibility(el.__splide, el);
      }
      return;
    }
    el.dataset.splideInited = '1';

    var widthAttr = el.getAttribute('data-width');
    var spWidthAttr = el.getAttribute('data-sp-width');
    var isMobile = (window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
    var defaultPc = widthAttr ? parseInt(widthAttr, 10) : 220;
    var defaultSp = spWidthAttr ? parseInt(spWidthAttr, 10) : 150;
    var width = isMobile ? defaultSp : defaultPc;
    if (isNaN(width)) width = isMobile ? 150 : 220;

    var autoplay = el.dataset.autoplay === 'true';
    var type = el.dataset.type || 'loop';
    var pagination = getSplideBoolOption(el, 'pagination', true);
    var typeFinal = pagination ? type : 'slide';
    var arrows = getSplideBoolOption(el, 'arrows', true);
    var gap = getSplideGap(el, 12);

    // 追加data属性の反映
    var isScroll = getSplideBoolOption(el, 'isScroll', true);
    var hasCopy = getSplideBoolOption(el, 'hasCopy', true);

    // ルートに has-copy / no-copy を付与
    el.classList.toggle('has-copy', hasCopy);
    el.classList.toggle('no-copy', !hasCopy);

    var options = {
      type: typeFinal,
      fixedWidth: width,
      gap: gap + 'px',
      padding: '3rem',
      perMove: 1,
      arrows: arrows,
      pagination: pagination,
      trimSpace: false,
      autoplay: autoplay,
      rewind: false,
      drag: 'free',
      snap: false
    };

    // data-is-scroll="false" の場合はドラッグ無効
    if (!isScroll) {
      options.drag = false;
    }

    var splide = new Splide(el, options).mount();
    el.__splide = splide;

    setupSplideArrowVisibility(splide, el);
  });


  // ------------------------------------------
  // ③ splide-arrow-outside（外側矢印版）
  // ------------------------------------------
  rootEl.querySelectorAll('.splide-arrow-outside').forEach(function (el) {

    if (el.dataset.splideInited === '1') {
      if (el.__splide && typeof el.__splide.refresh === 'function') {
        try { el.__splide.refresh(); } catch (e) {}
        setupSplideArrowVisibility(el.__splide, el);
      }
      return;
    }
    el.dataset.splideInited = '1';

    var widthAttr = el.getAttribute('data-width');
    var spWidthAttr = el.getAttribute('data-sp-width');
    var isMobile = (window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
    var defaultPc = widthAttr ? parseInt(widthAttr, 10) : 220;
    var defaultSp = spWidthAttr ? parseInt(spWidthAttr, 10) : 150;
    var width = isMobile ? defaultSp : defaultPc;
    if (isNaN(width)) width = isMobile ? 150 : 220;

    var autoplay = el.dataset.autoplay === 'true';
    var type = el.dataset.type || 'loop';
    var pagination = getSplideBoolOption(el, 'pagination', true);
    var typeFinal = pagination ? type : 'slide';
    var arrows = getSplideBoolOption(el, 'arrows', true);
    var gap = getSplideGap(el, 20);

    // slideは既定でフリースクロールにする（data-free-scrollで上書き可）
    var freeScrollDefault = (typeFinal === 'slide');
    var freeScroll = getSplideBoolOption(el, 'freeScroll', freeScrollDefault);

    var options = {
      type: typeFinal,
      fixedWidth: width,
      gap: gap + 'px',
      padding: '0rem',
      perMove: 1,
      arrows: arrows,
      pagination: pagination,
      trimSpace: false,
      autoplay: autoplay,
      rewind: false
    };

    if (freeScroll) {
      options.drag = 'free';
      options.snap = false;
    }

    var splide = new Splide(el, options).mount();
    el.__splide = splide;

    setupSplideArrowVisibility(splide, el);
  });


  // ------------------------------------------
  // ④ splide-count-items（PC→TB→横→縦）
  // ------------------------------------------
  rootEl.querySelectorAll('.splide-count-items').forEach(function (el) {

    if (el.dataset.splideInited === '1') {
      if (el.__splide && typeof el.__splide.refresh === 'function') {
        try { el.__splide.refresh(); } catch (e) {}
        setupSplideArrowVisibility(el.__splide, el);
      }
      return;
    }
    el.dataset.splideInited = '1';

    var counts = (el.getAttribute('data-count') || '1')
      .split(',')
      .map(function (v) { return parseInt(v.trim(), 10); })
      .filter(function (v) { return !isNaN(v); });

    var pc = counts[0] || 1;
    var tb = counts[1] || pc;
    var st = counts[2] || tb;
    var sp = counts[3] || st;

    var autoplay = el.dataset.autoplay === 'true';
    var type = el.dataset.type || 'loop';
    var pagination = getSplideBoolOption(el, 'pagination', true);
    var typeFinal = pagination ? type : 'slide';
    var arrows = getSplideBoolOption(el, 'arrows', true);
    var gap = getSplideGap(el, 20);

    // slideは既定でフリースクロールにする（data-free-scrollで上書き可）
    var freeScrollDefault = (typeFinal === 'slide');
    var freeScroll = getSplideBoolOption(el, 'freeScroll', freeScrollDefault);

    var options = {
      type: typeFinal,
      gap: gap + 'px',
      padding: '2rem',
      perMove: 1,
      arrows: arrows,
      pagination: pagination,
      trimSpace: false,
      perPage: pc,
      autoplay: autoplay,
      rewind: false,
      breakpoints: {
        1024: { perPage: tb },
        768: { perPage: st },
        480: { perPage: sp }
      }
    };

    if (freeScroll) {
      options.drag = 'free';
      options.snap = false;
    }

    var splide = new Splide(el, options).mount();
    el.__splide = splide;

    setupSplideArrowVisibility(splide, el);
  });

};


// ==========================================
// 遅延初期化（IntersectionObserver）
// data-lazy-init="true" が付いているSplideは画面に入るまで初期化を遅延
// ==========================================
function setupLazySplides() {
  var lazyElements = document.querySelectorAll('[data-lazy-init="true"]');
  if (!lazyElements.length || !window.IntersectionObserver) {
    // IntersectionObserver非対応ブラウザは即時初期化
    if (window.initSplideCarousels) {
      window.initSplideCarousels(document);
    }
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var target = entry.target;
        // data-lazy-init属性を削除してマーク済みに
        target.removeAttribute('data-lazy-init');
        // この要素だけ初期化
        if (window.initSplideCarousels) {
          // 親要素を渡してこの要素を含むスコープで初期化
          window.initSplideCarousels(target.parentElement || document);
        }
        // 監視解除
        observer.unobserve(target);
      }
    });
  }, {
    rootMargin: '200px 0px', // 画面下から200px手前で初期化開始
    threshold: 0.01
  });

  lazyElements.forEach(function(el) {
    observer.observe(el);
  });
}

// 初回ページ表示時
document.addEventListener('DOMContentLoaded', function () {
  // data-lazy-init が付いていないSplideを即時初期化
  if (window.initSplideCarousels) {
    var immediateElements = document.querySelectorAll('.splide:not([data-lazy-init])');
    immediateElements.forEach(function(el) {
      window.initSplideCarousels(el.parentElement || document);
    });
  }

  // 遅延初期化Splideの監視を開始
  setupLazySplides();
});


document.addEventListener('partial:updated', function (ev) {
  if (typeof window.initSplideCarousels !== 'function') {
    return;
  }

  var roots = (ev.detail && ev.detail.roots) ? ev.detail.roots : [];

  roots.forEach(function (sel) {
    var root = document.querySelector(sel);
    if (!root) {
      return;
    }
    window.initSplideCarousels(root);
  });
});